import { useEffect, useRef } from 'react';

export default (func: any, deps: any) => {
	const didMount = useRef(false);

	useEffect(() => {
		if (didMount.current) func();
		else didMount.current = true;
	}, deps);
};
